import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { IconButton, InputAdornment } from '@mui/material';
import { useWrappedSource } from 'ra-core';
import { TextInput, type TextInputProps } from 'react-admin';
import { useWatch } from 'react-hook-form';
import { isUrl } from './isUrl';

export type UrlInputProps = TextInputProps;

export const UrlInput = (props: UrlInputProps) => {
    const { source, InputProps: inputPropsProp, ...rest } = props;
    const fieldName = useWrappedSource(source ?? '');
    const value = useWatch({ name: fieldName });

    const url = typeof value === 'string' ? value.trim() : '';
    const canOpen =
        url.length > 0 &&
        (url.startsWith('http://') || url.startsWith('https://'));

    const handleOpenUrl = () => {
        if (canOpen) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <TextInput
            source={source}
            type="url"
            validate={isUrl}
            InputProps={{
                ...inputPropsProp,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            size="small"
                            onClick={handleOpenUrl}
                            disabled={!canOpen}
                            aria-label="Open URL in new tab"
                            edge="end"
                        >
                            <OpenInNewIcon sx={{ fontSize: '0.875em' }} />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            {...rest}
        />
    );
};
